import { AllhomesSearchPropertyType } from './allhomes-search-property-type';
export default AllhomesSearchPropertyType;